import { render, staticRenderFns } from "./MaquilaModal.vue?vue&type=template&id=497f6037&scoped=true"
import script from "./MaquilaModal.vue?vue&type=script&lang=js"
export * from "./MaquilaModal.vue?vue&type=script&lang=js"
import style0 from "./MaquilaModal.vue?vue&type=style&index=0&id=497f6037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f6037",
  null
  
)

export default component.exports